import { render } from "./DiscussionProfileModesPage.vue?vue&type=template&id=8eae2198&scoped=true"
import script from "./DiscussionProfileModesPage.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./DiscussionProfileModesPage.vue?vue&type=script&charset=utf-8&lang=js"

import "./DiscussionProfileModesPage.vue?vue&type=style&index=0&id=8eae2198&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8eae2198"]])

export default __exports__